import { Box, Stack, TextField, Typography, Chip } from "@mui/material";
import { ELECTRICITY_POINT_TYPES } from "../../dataModels";
import { useState } from "react";
import { FormControl, InputLabel, Select, MenuItem, Alert } from "@mui/material";
import { calculateRoomArea, isElectricityValid } from "../../dataModels";
import { WALL_TYPES } from "../../dataModels/wall";
import DeleteIcon from '@mui/icons-material/Delete';
export function MainScreen({ room, onChange }) {
    const [selectedTypeToAdd, setSelectedTypeToAdd] = useState('');
    const area = calculateRoomArea(room?.walls);
    const currentPointsCount = room?.walls?.flatMap(w => w.electricityPoints)?.length || 0;
    const isElectricityValidResult = isElectricityValid(room);
    
    // Determine current wall type (use first wall's type if all walls have the same type, otherwise empty)
    const walls = room?.walls || [];
    const allWallsSameType = walls.length > 0 && walls.every(wall => wall.type === walls[0]?.type);
    const currentWallType = allWallsSameType ? (walls[0]?.type || '') : '';
    return (
        <Box sx={{ flex: 1, overflowY: 'auto', p: 2, display: 'flex', flexDirection: 'column' }}>
            <Stack spacing={3}>
                {/* Room Info Section */}
                <Box>
                    <Typography variant="h6" gutterBottom>מידע כללי</Typography>
                    <Stack spacing={2}>
                        <TextField
                            label="שם החדר"
                            value={room.name}
                            onChange={(e) => onChange({ ...room, name: e.target.value })}
                            fullWidth
                        />

                        <TextField
                            label="מספר חדר"
                            type="number"
                            value={room.number}
                            onChange={(e) => onChange({ ...room, number: e.target.value })}
                            fullWidth
                        />

                        <TextField
                            label="סיווג"
                            value={room.classification}
                            onChange={(e) => onChange({ ...room, classification: e.target.value })}
                            fullWidth
                        />

                        <FormControl fullWidth>
                            <InputLabel>סוג קירות</InputLabel>
                            <Select
                                value={currentWallType}
                                onChange={(e) => {
                                    const newType = e.target.value;
                                    const updatedWalls = (room.walls || []).map(wall => ({
                                        ...wall,
                                        type: newType
                                    }));
                                    onChange({ ...room, walls: updatedWalls });
                                }}
                                label="סוג קירות"
                            >
                                {Object.values(WALL_TYPES).map((type) => (
                                    <MenuItem key={type} value={type}>
                                        {type === WALL_TYPES.REGULAR && 'רגיל'}
                                        {type === WALL_TYPES.SAFETY && 'בטיחות'}
                                        {type === WALL_TYPES.OTHER && 'אחר'}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <Box>
                            <Typography variant="body2" gutterBottom sx={{ mb: 1 }}>
                                סוגי נקודות חשמל נדרש
                            </Typography>
                            <Stack direction="row" spacing={1} sx={{ mb: 1, flexWrap: 'wrap', gap: 1 }}>
                                {(room.requiredElectricity || []).map((type, index) => (
                                    <Chip
                                        key={`${type}-${index}`}
                                        label={type}
                                        onDelete={() => {
                                            const newRequired = [...(room.requiredElectricity || [])];
                                            newRequired.splice(index, 1);
                                            onChange({ ...room, requiredElectricity: newRequired });
                                        }}
                                        deleteIcon={<DeleteIcon />}
                                    />
                                ))}
                            </Stack>
                            <FormControl fullWidth>
                                <InputLabel>הוסף סוג נקודת חשמל</InputLabel>
                                <Select
                                    value={selectedTypeToAdd}
                                    onChange={(e) => {
                                        const newType = e.target.value;
                                        if (newType) {
                                            const newRequired = [...(room.requiredElectricity || []), newType];
                                            onChange({ ...room, requiredElectricity: newRequired });
                                            setSelectedTypeToAdd(''); // Reset select
                                        }
                                    }}
                                    label="הוסף סוג נקודת חשמל"
                                >
                                    {ELECTRICITY_POINT_TYPES.map((type) => (
                                        <MenuItem key={type} value={type}>
                                            {type}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>

                        <TextField
                            label="זווית סיבוב (מעלות)"
                            type="number"
                            value={room.rotation}
                            onChange={(e) => onChange({ ...room, rotation: parseFloat(e.target.value) || 0 })}
                            inputProps={{ min: 0, max: 360, step: 1 }}
                            fullWidth
                            helperText="0 = ללא סיבוב, 90 = סיבוב 90 מעלות נגד כיוון השעון"
                        />

                        <Typography variant="body1" fontWeight="bold">
                            שטח החדר: {area.toFixed(2)} m²
                        </Typography>

                        <Alert severity={isElectricityValidResult ? 'success' : 'error'}>
                            נקודות חשמל: {isElectricityValidResult ? '✓' : '✗'}
                        </Alert>
                    </Stack>
                </Box>
                
            </Stack>
        </Box>)
}

